export default "__VITE_ASSET__BI2gwDJk__"